import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';

class CancelarEdicion extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(value){
        let modalId= this.props.idModal
        if(value == "aceptar"){
            this.props.toggleModal(modalId);
            this.props.confirmarClienteTarjeta(true);
            this.props.edicionClienteAdicional(this.props.idAdicional);
        }else{
            this.props.toggleModal(modalId);
        }
    }
    
    render() {
        let modalId= "CancelarEdicion"+this.props.idModal
        return (
                <div className="modal fade-out" id={modalId} role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog">
                            <div className="modal-content modal-wide">
                                <div className="modal-header-new">
                                    <div className="closeNew" data-dismiss="modal" aria-hidden="true"><label className="ti-close clickable"></label></div>
                                    <h2 className="modal-title-new" id="myModalLabel">Cancelar Edición</h2>
                                </div>
                                <div className="modal-body-new">{"¿Está seguro que quiere desestimar el alta/modificación del integrante " + this.props.integrante + " ?" }</div>
                                <div className="modal-footer-new">
                                    <button className="btn btn-cta" onClick={()=>this.handleClick("aceptar")} >Sí</button>
                                    <button className="btn btn-secondary button-separation-foot" onClick={()=>this.handleClick("cancelar")}>No</button>
                                </div>
                        </div>
                    </div>
                </div>
        );
    }
};

export default CancelarEdicion